
import React from 'react';
import { Link } from 'lucide-react';
import ReferralURLForm from '@/components/ReferralURLForm';
import { ReferralURLConfig } from '@/utils/config/types';

interface ReferralURLSettingsTabProps {
  urls: ReferralURLConfig[];
  onSaved: () => void;
}

const ReferralURLSettingsTab: React.FC<ReferralURLSettingsTabProps> = ({ 
  urls, 
  onSaved 
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Link className="h-5 w-5 text-primary" />
        <h2 className="text-xl font-semibold">Referral URLs</h2>
      </div>
      <ReferralURLForm 
        urls={urls} 
        onSaved={onSaved} 
      />
    </div>
  );
};

export default ReferralURLSettingsTab;
